(ns frontend.ui.component.lp-portal.report.body.voima.fund.pdf-pages.fund-overview
  (:require
   [common.util :as cu]
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.voima-components.pdf.column.view :as column]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.report.component.horizontal-table.pdf-view :as horizontal-table-pdf]
   [frontend.ui.component.lp-portal.report.component.vertical-table.pdf-view :as vertical-table-pdf]
   [frontend.ui.component.lp-portal.report.component.block-table.pdf-view :as block-table-pdf]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.voima-components.pdf.card.view :as card]
   [frontend.ui.style.theme.core :as theme]
   [potpuri.core :as potpuri]))

(defn pdf-chart-y-axis-config
  "Forces y-axes to only be on the right side"
  [config]
  (let [y-axis (->> config
                    :yAxis)]
    (if (sequential? y-axis)
      (->> y-axis
           (mapv (fn [y-axis]
                   (update y-axis :opposite (constantly true)))))
      (assoc y-axis :opposite true))))

(defn empty-chart-data?
  [data chart-key]
  (->> data
       chart-key
       :figures
       :series
       (filter (fn [{:keys [data]}]
                 (seq (remove nil? data))))
       (count)
       (= 0)))



(defn total-investment-svg
  [{:keys [fund-overview]}]
  (let [figures (-> fund-overview
                    :total-investment
                    :figures)]
    (when-not (empty-chart-data? fund-overview :total-investment)
      [(card/first-row-first-column-card
        "Total investment"
        false
        {:svg (chart-view/chart-svg "highcharts"
                                    (potpuri/deep-merge figures
                                                        {:chart  {:width   700
                                                                  :height  350
                                                                  :spacing [10 50 0 0]
                                                                  :margin  [0 200 50 0]}
                                                         :legend {:verticalAlign "top"
                                                                  :align         "left"
                                                                  :floating      true
                                                                  :padding       0}
                                                         :yAxis  (pdf-chart-y-axis-config figures)}))
         :fit [page/half-page-without-margins 200]}
        (text-content/optional-footer (:total-investment fund-overview)))])))

(defn number-of-employees-svg
  [{:keys [fund-overview]}]
  (let [figures (-> fund-overview
                    :number-of-employees
                    :figures)]
    (when-not (empty-chart-data? fund-overview :number-of-employees)
      [(card/first-row-second-column-card
        "Number of employees across active portfolio"
        false
        {:svg (chart-view/chart-svg "highcharts"
                                    (potpuri/deep-merge figures
                                                        {:chart  {:width   700
                                                                  :height  350
                                                                  :spacing [10 50 0 0]
                                                                  :margin  [0 100 50 0]}
                                                         :legend {:verticalAlign "top"
                                                                  :align         "left"
                                                                  :floating      true
                                                                  :padding       0}
                                                         :yAxis  (pdf-chart-y-axis-config figures)}))
         :fit [page/half-page-without-margins 200]}
        (text-content/optional-footer (:number-of-employees fund-overview)))])))

(defn initial-and-follow-on-investments-svg
  [{:keys [fund-overview]}]
  (let [figures (-> fund-overview
                    :initial-and-follow-on-investments
                    :figures)]
    (when-not (empty-chart-data? fund-overview :initial-and-follow-on-investments)
      [(card/second-row-first-column-card
        "Initial and follow on investments"
        false
        {:svg (chart-view/chart-svg "highcharts"
                                    (potpuri/deep-merge figures
                                                        {:chart  {:width   700
                                                                  :height  350
                                                                  :spacing [10 50 0 0]
                                                                  :margin  [0 100 50 0]}
                                                         :legend {:verticalAlign "top"
                                                                  :align         "left"
                                                                  :floating      true
                                                                  :padding       0}
                                                         :yAxis  (pdf-chart-y-axis-config figures)}))
         :fit [page/half-page-without-margins 200]}
        (text-content/optional-footer (:initial-and-follow-on-investments fund-overview)))])))

(defn total-investment-by-geography-svg
  [{:keys [fund-overview]}]
  (let [figures (-> fund-overview
                    :total-investment-by-geography
                    :figures)]
    (when-not (empty-chart-data? fund-overview :total-investment-by-geography)
      [(card/first-row-first-column-card
        "Total investments, by geography"
        false
        {:svg (chart-view/chart-svg "highcharts"
                                    (potpuri/deep-merge figures
                                                        {:chart  {:width   700
                                                                  :height  350
                                                                  :spacing [10 50 0 0]
                                                                  :margin  [0 100 50 0]}
                                                         :legend {:verticalAlign "top"
                                                                  :align         "left"
                                                                  :floating      true
                                                                  :padding       0}
                                                         :yAxis  (pdf-chart-y-axis-config figures)}))
         :fit [page/half-page-without-margins 200]}
        (text-content/optional-footer (:total-investment-by-geography fund-overview)))])))

(defn combined-revenue-svg
  [{:keys [fund-overview]}]
  (let [figures (-> fund-overview
                    :combined-revenue-active-portfolio
                    :figures)]
    (when-not (empty-chart-data? fund-overview :combined-revenue-active-portfolio)
      [(card/second-row-first-column-card
        "Combined revenue, active portfolio (EUR)"
        false
        {:svg (chart-view/chart-svg "highcharts"
                                    (potpuri/deep-merge figures
                                                        {:chart  {:width   700
                                                                  :height  350
                                                                  :spacing [10 50 0 0]
                                                                  :margin  [0 100 50 0]}
                                                         :legend {:verticalAlign "top"
                                                                  :align         "left"
                                                                  :floating      true
                                                                  :padding       0}
                                                         :yAxis  (pdf-chart-y-axis-config figures)}))
         :fit [page/half-page-without-margins 200]}
        (text-content/optional-footer (:combined-revenue-active-portfolio fund-overview)))])))

(defn historical-fund-performance-svg
  [{:keys [fund-overview]}]
  (let [figures (-> fund-overview
                    :historical-fund-performance
                    :figures)]
    (when-not (empty-chart-data? fund-overview :historical-fund-performance)
      [(card/second-row-second-column-card
        "Historical fund performance"
        false
        {:svg (chart-view/chart-svg "highcharts"
                                    (potpuri/deep-merge figures
                                                        {:chart  {:width   700
                                                                  :height  350
                                                                  :spacing [10 50 0 0]
                                                                  :margin  [0 100 50 0]}
                                                         :legend {:verticalAlign "top"
                                                                  :align         "left"
                                                                  :floating      true
                                                                  :padding       0}
                                                         :yAxis  (pdf-chart-y-axis-config figures)}))
         :fit [page/half-page-without-margins 200]}
        (text-content/optional-footer (:historical-fund-performance fund-overview)))])))

(defn value-progression-svg
  [{:keys [fund-overview]}]
  (let [figures (-> fund-overview
                    :value-progression
                    :figures)]
    (when-not (empty-chart-data? fund-overview :value-progression)
      [(card/first-row-second-column-card
        "Value progression"
        false
        {:svg (chart-view/chart-svg "highcharts"

                                    (potpuri/deep-merge figures
                                                        {:chart  {:width   700
                                                                  :height  350
                                                                  :spacing [10 50 0 0]
                                                                  :margin  [0 100 50 0]}
                                                         :legend {:verticalAlign "top"
                                                                  :align         "left"
                                                                  :floating      true
                                                                  :padding       0}
                                                         :yAxis  (pdf-chart-y-axis-config figures)}))
         :fit [page/half-page-without-margins 200]}
        (text-content/optional-footer (:value-progression fund-overview)))])))

(defn fund-value-bridge-svg
  [{:keys [fund-overview]}]
  (let [figures (-> fund-overview
                    :fund-value-bridge
                    :figures)]
    [(card/second-row-second-column-card
      "Fund value bridge"
      false
      {:svg (chart-view/chart-svg "highcharts"

                                  (potpuri/deep-merge figures
                                                      {:chart  {:width   700
                                                                :height  350
                                                                :spacing [10 50 0 0]
                                                                :margin  [0 100 80 0]}
                                                       :legend {:verticalAlign "top"
                                                                :align         "left"
                                                                :floating      true
                                                                :padding       0}
                                                       :xAxis  {:labels {:rotation 25
                                                                         :style    {:fontSize "7pt"}
                                                                         :align    "left"}}
                                                       :yAxis  (pdf-chart-y-axis-config figures)}))
       :fit [page/half-page-without-margins 200]}
      (text-content/optional-footer (:fund-value-bridge fund-overview)))]))

(defn dealflow-map-svg
  [{:keys [fund-overview]}]
  (let [map-data (->> fund-overview
                      :investments-map
                      :figures
                      :series
                      (first)
                      :data)
        map-table-data (->> map-data
                            (filter (fn [item]
                                      (= (:hc-key item) nil)))
                            (vec))
        data {:figures {:rows (->> map-table-data
                                   (mapv (fn [item]
                                           {:row-data      [(:country item) (:y item)]
                                            :row-highlight (theme/color [:lp-report :table :pdf
                                                                         :heading-info-color :bg])})))
                        :table-row-alignment "tabular"
                        :table-style :table-style/none
                        :pdf-column-width [(- (/ page/half-page-without-margins 2) 9.5)
                                           (- (/ page/half-page-without-margins 2) 9.5)]
                        :column-font-style-row [nil
                                                "bold"]}}]

    [(card/first-row-first-column-card
      "Dealflow"
      false
      {:svg (chart-view/geomap-svg "highcharts"
                                   (potpuri/deep-merge (-> fund-overview
                                                           :dealflow-map
                                                           :figures)
                                                       {:chart   {:width   500
                                                                  :height  500
                                                                  :spacing [0 0 0 0]
                                                                  :margin  [0 0 0 0]}
                                                        :mapView {:projection {:name "WebMercator"}
                                                                  :center     [4 63]
                                                                  :zoom       3.1}
                                                        :title   {:text ""}}))
       :fit [page/half-page-without-margins 400]}
      (block-table-pdf/table data)
      (text-content/optional-footer (:dealflow-map fund-overview)))]))

(defn investments-map-svg
  [{:keys [fund-overview]}]
  (let [map-data (->> fund-overview
                      :investments-map
                      :figures
                      :series
                      (first)
                      :data)
        map-table-data (->> map-data
                            (filter (fn [item]
                                      (= (:hc-key item) nil)))
                            (vec))
        data {:figures {:rows (->> map-table-data
                                   (mapv (fn [item]
                                           {:row-data      [(:country item) (:y item)]
                                            :row-highlight (theme/color [:lp-report :table :pdf
                                                                         :heading-info-color :bg])})))
                        :table-row-alignment "tabular"
                        :table-style :table-style/none
                        :pdf-column-width [(- (/ page/half-page-without-margins 2) 9.5)
                                           (- (/ page/half-page-without-margins 2) 9.5)]
                        :column-font-style-row [nil
                                                "bold"]}}]
    [(card/first-row-second-column-card
      "Investments"
      false
      {:svg (chart-view/geomap-svg "highcharts"

                                   (potpuri/deep-merge (-> fund-overview
                                                           :investments-map
                                                           :figures)
                                                       {:chart   {:width   500
                                                                  :height  500
                                                                  :spacing [0 0 0 0]
                                                                  :margin  [0 0 0 0]}
                                                        :mapView {:projection {:name "WebMercator"}
                                                                  :center     [4 63]
                                                                  :zoom       3.1}
                                                        :title   {:text ""}}))
       :fit [page/half-page-without-margins 400]}
      (block-table-pdf/table data)
      (text-content/optional-footer (:investments-map fund-overview)))
    ]))


(defn fund-overview-page-1
  [data]
  (let [remove-page? (and (empty-chart-data? (:fund-overview data) :total-investment)
                          (empty-chart-data? (:fund-overview data) :initial-and-follow-on-investments)
                          (empty-chart-data? (:fund-overview data) :number-of-employees)
                          (empty-chart-data? (:fund-overview data) :fund-value-bridge))]
    (when-not remove-page?
      (page/page
       (page/page-title-with-line {:fund-name  (:fund-name data)
                                   :page-title "Fund overview - Charts 1"
                                   :toc-item   true})
       (column/columns

        [(total-investment-svg data)
         (initial-and-follow-on-investments-svg data)]
        [(number-of-employees-svg data)
         (fund-value-bridge-svg data)])))))

(defn fund-overview-page-2
  [data]
  (let [remove-page? (and (empty-chart-data? (:fund-overview data) :total-investment-by-geography)
                          (empty-chart-data? (:fund-overview data) :combined-revenue-active-portfolio)
                          (empty-chart-data? (:fund-overview data) :value-progression)
                          (empty-chart-data? (:fund-overview data) :historical-fund-performance))]
    (when-not remove-page?
      (page/page
       (page/page-title-with-line {:fund-name  (:fund-name data)
                                   :page-title "Fund overview - Charts 2"
                                   :toc-item   true})
       (column/columns
        (column/column
         (total-investment-by-geography-svg data)
         (combined-revenue-svg data))
        (column/column
         (value-progression-svg data)
         (historical-fund-performance-svg data)
        ))))))

(defn empty-map-data?
  [data map-key]
  (->> data
       map-key
       :figures
       :series
       (first)
       :data
       (filter (fn [country-data]
                 (not (cu/blank-value? (:y country-data)))))
       (count)
       (= 0)))

(defn empty-table-data?
  [data key]
  (->> data
       key
       :figures
       :rows
       (filter (fn [{:keys [row-data]}]
                 (seq (remove nil? (rest row-data)))))
       (count)
       (= 0)))

(defn fund-overview-page-3
  [{:keys [fund-overview] :as data}]
  (let [remove-page? (and (empty-map-data? fund-overview :dealflow-map)
                          (empty-map-data? fund-overview :investments-map))]
    (when-not remove-page?
      (page/page
       (page/page-title-with-line {:fund-name  (:fund-name data)
                                   :page-title "Fund overview - Maps"
                                   :toc-item   true})
       (column/columns
        (column/column
         (when-not (empty-map-data? fund-overview :dealflow-map)
           (dealflow-map-svg data)))
        (column/column
         (when-not (empty-map-data? fund-overview :investments-map)
           (investments-map-svg data))))))))

(defn fund-performance-status-tables-1
  [{:keys [fund-overview] :as data}]
  (let [remove-page? (and (empty-table-data? fund-overview :net-asset-value)
                          (empty-table-data? fund-overview :key-metrics))]
    (when-not remove-page?
      (page/page
       (page/page-title-with-line {:fund-name  (:fund-name data)
                                   :page-title "Fund overview - Net asset value"
                                   :toc-item   true})
       (card/table-card ""
                        (horizontal-table-pdf/table (->> fund-overview
                                                         :net-asset-value))
                        (text-content/optional-footer (->> fund-overview
                                                           :net-asset-value)))
       (card/table-card ""
                        (vertical-table-pdf/table (->> fund-overview
                                                       :key-metrics))
                        (text-content/optional-footer (->> fund-overview
                                                           :key-metrics)))))))

(defn carried-interest-and-expenses-tables-1
  [{:keys [fund-overview] :as data}]
  (let [remove-page? (and (empty-table-data? fund-overview :management-fees)
                          (empty-table-data? fund-overview :transaction-and-other-fees))]
    (when-not remove-page?
      (page/page
       (page/page-title-with-line {:fund-name  (:fund-name data)
                                   :page-title "Fund overview - Management fees"
                                   :toc-item   true})
       (card/table-card ""
                        (vertical-table-pdf/table (->> fund-overview
                                                       :management-fees))
                        (text-content/optional-footer (->> fund-overview
                                                           :management-fees)))
       (card/table-card ""
                        (vertical-table-pdf/table (->> fund-overview
                                                       :transaction-and-other-fees))
                        (text-content/optional-footer (->> fund-overview
                                                           :transaction-and-other-fees)))))))

(defn carried-interest-and-expenses-tables-2
  [{:keys [fund-overview] :as data}]
  (let [remove-page? (and (empty-table-data? fund-overview :carried-interest)
                          (empty-table-data? fund-overview :fund-operating-expenses))]
    (when-not remove-page?
      (page/page
       (page/page-title-with-line {:fund-name  (:fund-name data)
                                   :page-title "Fund overview - Transaction and other fees"
                                   :toc-item   true})
       (card/table-card ""
                        (vertical-table-pdf/table (->> fund-overview
                                                       :carried-interest))
                        (text-content/optional-footer (->> fund-overview
                                                           :carried-interest)))
       (card/table-card ""
                        (vertical-table-pdf/table (->> fund-overview
                                                       :fund-operating-expenses))
                        (text-content/optional-footer (->> fund-overview
                                                           :fund-operating-expenses)))))))

(defn bridge-finance-fund-leverage-facilities-tables-1
  [{:keys [fund-overview] :as data}]
  (let [remove-page? (and (empty-table-data? fund-overview :bridge-finance-and-fund-leverage)
                          (empty-table-data? fund-overview :bridging-facility))]
    (when-not remove-page?
      (page/page
       (page/page-title-with-line {:fund-name  (:fund-name data)
                                   :page-title "Fund overview - Bridge finance and fund leverage"
                                   :toc-item   true})
       (card/table-card ""
                        (block-table-pdf/table (->> fund-overview
                                                    :bridge-finance-and-fund-leverage))
                        (text-content/optional-footer (->> fund-overview
                                                           :bridge-finance-and-fund-leverage)))
       (card/table-card ""
                        (vertical-table-pdf/table (->> fund-overview
                                                       :bridging-facility))
                        (text-content/optional-footer (->> fund-overview
                                                           :bridging-facility)))))))

(defn fund-overview-pages
  [data]
  [(fund-overview-page-1 data)
   (fund-overview-page-2 data)
   (fund-overview-page-3 data)
   (fund-performance-status-tables-1 data)
   (carried-interest-and-expenses-tables-1 data)
   (carried-interest-and-expenses-tables-2 data)
   (bridge-finance-fund-leverage-facilities-tables-1 data)])
